<div class="qa-grid mm-page">
  <h2 class="mb-4">{{_(KEYS.GRID.WORKFLOW_INSTANCES)}}</h2>
  <div class="card mb-5">
    <div class="card-body">
      <button type="button" class="card-title mm-pane-toggle"
              (click)="isSearchCollapsed = !isSearchCollapsed"
              [attr.aria-expanded]="!isSearchCollapsed" aria-controls="workflow-instance-grid-search-fields">
        <span class="mm-pane-toggle-label">
          <i class="fa fa-search" aria-hidden="true"></i>
          <span>{{_(KEYS.GRID.SEARCH)}}</span>
        </span>
        <span class="mm-pane-toggle-icon" aria-hidden="true">
          <i class="fa" [ngClass]="{'fa-chevron-down': isSearchCollapsed, 'fa-chevron-up': !isSearchCollapsed}"></i>
        </span>
      </button>
      <div id="workflow-instance-grid-search-fields" class="card-text" [ngbCollapse]="isSearchCollapsed">
        <ngmedax-client-search
          [(filter)]="clientFilter"
          [(customFilter)]="customFilter"
          (searchChange)="onFilterChange()"
        >
          <div extraFields class="extra-fields-container">
            <hr class="extra-fields-divider">
            <div class="extra-fields-grid">
              <div class="search-field">
                <label>{{_(KEYS.GRID.STATUS)}}</label>
                <select class="form-control" [(ngModel)]="filter.status"
                        (blur)="onFilterChange()" (change)="onFilterChange()">
                  <option value="" selected>--</option>
                  <option value="created">{{_(KEYS.GRID.STATUS_CREATED)}}</option>
                  <option value="submitted">{{_(KEYS.GRID.STATUS_SUBMITTED)}}</option>
                </select>
              </div>

              <div class="search-field">
                <label>{{_(KEYS.GRID.EXTERN)}}</label>
                <select class="form-control" [(ngModel)]="filter.externStatus"
                        (blur)="onFilterChange()" (change)="onFilterChange()">
                  <option value="" selected>--</option>
                  <option value="open">{{_(KEYS.GRID.EXTERN_STATUS_OPEN)}}</option>
                  <option value="pending">{{_(KEYS.GRID.EXTERN_STATUS_PENDING)}}</option>
                  <option value="done">{{_(KEYS.GRID.EXTERN_STATUS_DONE)}}</option>
                </select>
              </div>

              <div class="search-field">
                <label>{{_(KEYS.GRID.TYPE)}}</label>
                <select class="form-control" [(ngModel)]="filter.anonymous"
                        (blur)="onFilterChange()" (change)="onFilterChange()">
                  <option value="" selected>--</option>
                  <option value="1">{{_(KEYS.GRID.TYPE_NOT_ANONYMOUS)}}</option>
                  <option value="2">{{_(KEYS.GRID.TYPE_ANONYMOUS)}}</option>
                  <option value="3">{{_(KEYS.GRID.TYPE_PSEUDONYMOUS)}}</option>
                </select>
              </div>

              <div class="search-field search-field-span2">
                <label>{{_(KEYS.GRID.WORKFLOW)}}</label>
                <input class="form-control" [(ngModel)]="filter.workflow"
                       (paste)="onFilterChange()" (change)="onFilterChange()" (keydown)="onFilterChange()">
              </div>
            </div>
            <div class="extra-fields-grid-fullrow">
              <div class="search-field search-field-select2">
                <label>{{_(KEYS.GRID.QUESTIONNAIRES)}}</label>
                <app-select2
                  [hideLabel]="true"
                  [hideButton]="true"
                  [multiple]="true"
                  [options]="{width: '100%', placeholder: '...'}"
                  [(selected)]="filter.questionnaires"
                  (selectedChange)="onFilterChange()"
                >
                  <option *ngFor="let q of questionnaires" [value]="q.id">
                    {{q.meta.title[locale] || q.meta.title[defaultLocale] || '???'}}
                  </option>
                </app-select2>
              </div>
            </div>
          </div>
        </ngmedax-client-search>
      </div>
    </div>
  </div>
  <div class="card">
    <div class="card-body">
      <div class="card-title mm-pane-header" [class.mm-pane-collapsed]="isGridCollapsed">
        <div class="mm-pane-actions">
          <button class="btn btn-sm btn-success d-inline-block" (click)="onRefresh()">
              <i class="fa fa-refresh"></i>
            </button>
            <div class="auto-refresh-container d-inline-block ml-2">
              <select class="form-control form-control-sm auto-refresh-select"
                      [(ngModel)]="autoRefreshInterval"
                      (change)="onAutoRefreshChange()">
                <option *ngFor="let option of autoRefreshOptions" [value]="option.value">
                  {{option.value === 0 ? _(KEYS.GRID.AUTO_REFRESH) : _(option.label)}}
                </option>
              </select>
              <span *ngIf="autoRefreshInterval > 0" class="auto-refresh-indicator">
                <i class="fa fa-clock-o"></i>
              </span>
            </div>
        </div>
        <button type="button" class="mm-pane-toggle"
                (click)="isGridCollapsed = !isGridCollapsed"
                [attr.aria-expanded]="!isGridCollapsed" aria-controls="workflow-instance-grid-results">
          <span class="mm-pane-toggle-label"><span>{{_(KEYS.GRID.WORKFLOW_INSTANCES)}}</span></span>
          <span class="mm-pane-toggle-icon" aria-hidden="true">
            <i class="fa" [ngClass]="{'fa-chevron-down': isGridCollapsed, 'fa-chevron-up': !isGridCollapsed}"></i>
          </span>
        </button>
      </div>
      <div id="workflow-instance-grid-results" class="card-text" [ngbCollapse]="isGridCollapsed">
        <div class="table-scroll-container">
          <div class="mm-table-scroll"><table class="table">
            <thead>
              <tr>
                <th class="qa-cursor-pointer" (click)="onSortChange('workflow.name.de_DE')">
                  {{_(KEYS.GRID.WORKFLOW)}}
                  <i *ngIf="filter.sort === 'workflow.name.de_DE'" class="fa" [ngClass]="filter.order === 'asc' ? 'fa-arrow-up' : 'fa-arrow-down'"></i>
                </th>
                <th class="qa-cursor-pointer" (click)="onSortChange('client.lastName')">
                  {{_(KEYS.GRID.PATIENT)}}
                  <i *ngIf="filter.sort === 'client.lastName'" class="fa" [ngClass]="filter.order === 'asc' ? 'fa-arrow-up' : 'fa-arrow-down'"></i>
                </th>
                <th class="qa-cursor-pointer" (click)="onSortChange('status')">
                  {{_(KEYS.GRID.STATUS)}}
                  <i *ngIf="filter.sort === 'status'" class="fa" [ngClass]="filter.order === 'asc' ? 'fa-arrow-up' : 'fa-arrow-down'"></i>
                </th>
                <th>{{_(KEYS.GRID.EXTERN)}}</th>
                <th class="qa-cursor-pointer" (click)="onSortChange('updatedAt')">
                  {{_(KEYS.GRID.UPDATED_AT)}}
                  <i *ngIf="filter.sort === 'updatedAt'" class="fa" [ngClass]="filter.order === 'asc' ? 'fa-arrow-up' : 'fa-arrow-down'"></i>
                </th>
                <th>{{_(KEYS.GRID.OPTIONS)}}</th>
              </tr>
            </thead>
            <tbody>
              <ng-container *ngFor="let instance of workflowInstances; let pos = index; trackBy: trackInstance">
                <tr class="history-overview" [class.history-expanded]="expandedInstances.has(instanceKey(instance))">
                  <td class="history-workflow">
                    <span class="history-workflow-title">{{getWorkflowName(instance)}}</span>
                    <button type="button" class="history-toggle" (click)="toggleHistory(instance)"
                      [attr.aria-expanded]="expandedInstances.has(instanceKey(instance))"
                      [attr.aria-controls]="'workflow-history-' + instanceKey(instance)">
                      <i class="fa" [ngClass]="expandedInstances.has(instanceKey(instance)) ? 'fa-angle-up' : 'fa-angle-down'" aria-hidden="true"></i>
                      {{_(expandedInstances.has(instanceKey(instance)) ? KEYS.GRID.HIDE_HISTORY : KEYS.GRID.SHOW_HISTORY)}}
                    </button>
                  </td>
                  <td class="history-patient">
                    <ngmedax-client-grid-renderer [client]="instance.client" [clientId]="instance.clientId"
                      [canEdit]="canEditPatient" linkMode="route">
                    </ngmedax-client-grid-renderer>
                  </td>
                  <td class="history-status-cell">
                    <span *ngIf="getInstanceStatus(instance) as state" class="history-status"
                      [ngClass]="'history-status-' + state.tone" container="body"
                      [ngbTooltip]="_(state.label) + (isExpired(instance) ? ' · ' + (instance.validUntil | datex:dateFormat) : '')">
                      <i class="fa" [ngClass]="state.icon" aria-hidden="true"></i>{{_(state.label)}}
                    </span>
                    <span class="history-summary">{{getHistorySummary(instance) || _(KEYS.GRID.NO_STAGES)}}</span>
                  </td>
                  <td>
                    <select class="extern-status form-control form-control-sm" [(ngModel)]="instance.externStatus"
                      [attr.aria-label]="_(KEYS.GRID.EXTERN)" (change)="onExternStatusChange(instance, $event.target.value)">
                      <option value="open">{{_(KEYS.GRID.EXTERN_STATUS_OPEN)}}</option>
                      <option value="pending">{{_(KEYS.GRID.EXTERN_STATUS_PENDING)}}</option>
                      <option value="done">{{_(KEYS.GRID.EXTERN_STATUS_DONE)}}</option>
                    </select>
                  </td>
                  <td class="history-date">{{instance.updatedAt | datex:dateFormat}}</td>
                <td class="options">
                  <button class="btn btn-sm btn-primary"
                          (click)="onContinueWorkflow(instance)"
                          ngbTooltip="{{_(KEYS.GRID.CONTINUE_WORKFLOW)}}"
                          [disabled]="instance.status === 'canceled' || instance.status === 'submitted' || isExpired(instance)">
                    <i class="fa fa-play"></i>
                  </button>
                  <button class="btn btn-sm btn-primary ml-1"
                          (click)="onCopyWorkflowContinueLink(instance)"
                          ngbTooltip="{{_(KEYS.GRID.COPY_LINK_TO_CONTINUE)}}"
                          [disabled]="instance.status === 'canceled' || instance.status === 'submitted' || isExpired(instance)">
                    <i class="fa fa-copy"></i>
                  </button>
                  <button class="btn btn-sm btn-primary ml-1"
                          (click)="onShowQRCode(instance)"
                          ngbTooltip="{{_(KEYS.GRID.SHOW_QR_CODE_TO_CONTINUE)}}"
                          [disabled]="instance.status === 'canceled' || instance.status === 'submitted' || isExpired(instance)">
                    <i class="fa fa-qrcode"></i>
                  </button>
                </td>
                </tr>
                <tr class="history-detail-row" [hidden]="!expandedInstances.has(instanceKey(instance))"
                  [attr.id]="'workflow-history-' + instanceKey(instance)">
                  <td colspan="6">
                    <section class="history-detail" *ngIf="expandedInstances.has(instanceKey(instance))"
                      [attr.aria-label]="getWorkflowName(instance) + ': ' + _(KEYS.GRID.STAGES)">
                      <div class="history-detail-heading">
                        <h3>{{getWorkflowName(instance)}}</h3>
                        <a *ngIf="instance.workflow?.id" [routerLink]="['/module/workflow/crud', instance.workflow.id]">
                          {{_(KEYS.GRID.OPEN_TEMPLATE)}} <i class="fa fa-angle-right" aria-hidden="true"></i>
                        </a>
                      </div>
                      <dl class="history-meta">
                        <div><dt>{{_(KEYS.GRID.ID)}}</dt><dd class="history-id">{{instance.uid || instance.id}}</dd></div>
                        <div><dt>{{_(KEYS.GRID.CREATED_AT)}}</dt><dd>{{instance.createdAt | datex:detailDateFormat}}</dd></div>
                        <div><dt>{{_(KEYS.GRID.UPDATED_AT)}}</dt><dd>{{instance.updatedAt | datex:detailDateFormat}}</dd></div>
                        <div *ngIf="instance.validUntil"><dt>{{_(KEYS.GRID.VALID_UNTIL)}}</dt>
                          <dd [class.history-expired]="isExpired(instance)">{{instance.validUntil | datex:detailDateFormat}}</dd>
                        </div>
                      </dl>
                      <ng-container *ngIf="instance.historyStages.length; else noStages">
                        <div class="history-columns" aria-hidden="true">
                          <span>{{_(KEYS.GRID.STAGE)}}</span><span>{{_(KEYS.GRID.STATUS)}}</span>
                          <div class="history-entry-columns"><span>{{_(KEYS.GRID.QUESTIONNAIRES)}}</span><span>{{_(KEYS.GRID.SUBMISSIONS)}} / {{_(KEYS.GRID.ASSETS)}}</span></div>
                        </div>
                        <ol class="history-step-list" [attr.aria-label]="_(KEYS.GRID.STAGES)">
                          <li class="history-step" *ngFor="let stage of instance.historyStages">
                            <div class="history-step-name">
                              <span class="stage-number" aria-hidden="true">{{stage.position + 1}}</span>
                              <span>{{getHistoryStageTitle(stage)}}</span>
                            </div>
                            <div class="history-step-state">
                              <span *ngIf="getSurveyStatus(stage.survey) as state" class="history-status"
                                [ngClass]="'history-status-' + state.tone">
                                <i class="fa" [ngClass]="state.icon" aria-hidden="true"></i>{{_(state.label)}}
                              </span>
                              <span class="history-status-date" *ngIf="stage.survey?.updatedAt">
                                <span aria-hidden="true">·</span>
                                {{stage.survey.updatedAt | datex:detailDateFormat}}
                              </span>
                            </div>
                            <div class="history-entries" *ngIf="stage.entries.length; else noQuestionnaires">
                              <div class="history-entry" *ngFor="let entry of stage.entries">
                                <div class="history-questionnaire-name">
                                  <ngmedax-questionnaire-origin
                                    *ngIf="entry.questionnaire || getStageQuestionnaire(stage, entry.id) as questionnaire; else questionnaireMissing"
                                    [questionnaire]="questionnaire" [locale]="locale" mode="stacked">
                                  </ngmedax-questionnaire-origin>
                                  <ng-template #questionnaireMissing><span class="stage-empty">{{_(KEYS.GRID.QUESTIONNAIRE_UNAVAILABLE)}}</span></ng-template>
                                </div>
                                <div class="history-files">
                                  <ng-container *ngIf="entry.submissions.length; else noFiles">
                                    <div class="history-submission" *ngFor="let submission of entry.submissions; let submissionPos = index">
                                      <div class="history-submission-date" *ngIf="submission.createdAt; else submissionNumber">
                                        <span>{{_(KEYS.GRID.SUBMITTED_AT)}}</span>
                                        <span>{{submission.createdAt | datex:detailDateFormat}}</span>
                                      </div>
                                      <ng-template #submissionNumber>
                                        <span class="history-submission-date" *ngIf="entry.submissions.length > 1">{{_(KEYS.GRID.SUBMISSION)}} {{submissionPos + 1}}</span>
                                      </ng-template>
                                      <div class="history-file-actions" *ngIf="hasDownloadContent(submission); else noFiles">
                                        <button type="button" class="btn btn-secondary btn-sm history-download" *ngIf="submission.bucketId"
                                          (click)="onOpenMediaCenterModal(submission)"><i class="fa fa-folder-open-o" aria-hidden="true"></i> {{_(KEYS.GRID.ASSETS)}}</button>
                                        <button type="button" class="btn btn-secondary btn-sm history-download"
                                          *ngIf="submission.uploadLinks && submission.uploadLinks['ownCloud']"
                                          (click)="onOpenLink(submission.uploadLinks['ownCloud'])"><i class="fa fa-cloud" aria-hidden="true"></i> ownCloud</button>
                                        <ng-container *ngIf="hasValidExports(submission)">
                                          <ng-container *ngFor="let export of submission.exports">
                                            <button type="button" class="btn btn-secondary btn-sm history-download"
                                              *ngIf="export && export.type && export.type !== 'EXTERN' && export.fileName" (click)="onDownload(export.fileName)">
                                              <i class="fa fa-download" aria-hidden="true"></i> {{_(export.type)}}
                                            </button>
                                          </ng-container>
                                        </ng-container>
                                      </div>
                                    </div>
                                  </ng-container>
                                  <ng-template #noFiles><span class="history-empty">{{_(KEYS.GRID.NO_FILES)}}</span></ng-template>
                                </div>
                              </div>
                            </div>
                            <ng-template #noQuestionnaires><span class="stage-empty">{{_(KEYS.GRID.NO_QUESTIONNAIRES)}}</span></ng-template>
                          </li>
                        </ol>
                      </ng-container>
                      <ng-template #noStages><span class="stage-empty">{{_(KEYS.GRID.NO_STAGES)}}</span></ng-template>
                    </section>
                  </td>
                </tr>
              </ng-container>
            </tbody>
          </table></div>
        </div>
        <div class="btn-toolbar justify-content-between mt-2 mb-2">
          <div class="justify-content-between">
            <div class="input-group">
              <div class="input-group qa-num-per-page">
                <select class="form-control custom-select" [(ngModel)]="displayPerPage" (change)="onPagingChange()">
                  <option value="2">2</option>
                  <option value="5">5</option>
                  <option value="10">10</option>
                  <option value="25">25</option>
                  <option value="50">50</option>
                </select>
                <span class="input-group-addon">{{_(KEYS.GRID.ENTRIES)}}</span>
              </div>
            </div>
          </div>
          <ngb-pagination
            [pageSize]="displayPerPage"
            [maxSize]="9"
            [rotate]="true"
            [(page)]="gridPageNumber"
            [collectionSize]="total"
            (pageChange)="onPagingChange()">
          </ngb-pagination>
        </div>
      </div>
    </div>
  </div>
</div>
